module.exports = __webpack_public_path__ + "img/work.d18ffbbe.svg";